import React, { useState } from "react";
import { Div, Label, Touchable, useWindowSize, Icon } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { IGroupMembers } from "@grassrootly/api";
import { images } from "../../../../layout/assets";

interface SwipeablePlayerItemProps {
  item: IGroupMembers;
  index: number;
  isAdmin: boolean;
  onPress: () => void;
  onRemove: () => void;
  onMakeAdmin: () => void;
}

export default function SwipeablePlayerItem({
  item,
  index,
  isAdmin,
  onPress,
  onRemove,
  onMakeAdmin,
}: SwipeablePlayerItemProps) {
  const { width } = useWindowSize();
  const [showActions, setShowActions] = useState(false);

  const handlePress = () => {
    if (showActions) {
      setShowActions(false);
    } else {
      onPress();
    }
  };

  const handleToggleActions = (e: any) => {
    if (isAdmin) {
      e.stopPropagation();
      setShowActions(!showActions);
    }
  };

  const handleRemove = () => {
    setShowActions(false);
    onRemove();
  };

  const handleMakeAdmin = () => {
    setShowActions(false);
    onMakeAdmin();
  };

  return (
    <Div>
      <Touchable
        classNames={[
          `${width > 720 ? "p16" : "p8"}`,
          index % 2 !== 0 ? "bgSecondaryMain" : "",
          "flexRow",
          "alignItemsCenter",
        ]}
        onPress={handlePress}
      >
        <Div classNames={["flex1"]}>
          <Div classNames={["flexRow", "alignItemsCenter", "justifyContentSpaceBetween"]}>
            <Div classNames={["alignItemsCenter"]}>
              <Div classNames={["bgPrimaryWashed", "p8", "rounded"]}>
                <Image
                  style={{
                    height: width > 720 ? 40 : 30,
                    width: width > 720 ? 40 : 30,
                    borderRadius: 40,
                  }}
                  resizeMode="cover"
                  source={
                    item.player_profile_picture ? { uri: item.player_profile_picture } : images.playerAvatar
                  }
                />
              </Div>
            </Div>
            <Div>
              <Label numberOfLines={2} ellipsizeMode="tail" type={width > 720 ? "l2Regular" : "l3Regular"}>
                {item.player_name}{" "}
                {item.is_group_owner ? (
                  <Icon classNames={["colorNeutralLighterLight"]} size={25} name="admin_panel_settings" />
                ) : null}
              </Label>
            </Div>

            <Div classNames={["flexRow", "alignItemsCenter", "gap8"]}>
              <Div classNames={["bgPrimaryWashed", "p8", "rounded", "flexRow", "alignItemsCenter", "gap4"]}>
                <Label
                  classNames={["colorSecondaryContrast"]}
                  numberOfLines={2}
                  ellipsizeMode="tail"
                  type={width > 720 ? "l2Regular" : "l3Regular"}
                >
                  {item.points_earned}
                </Label>
                <Label
                  classNames={["colorSecondaryContrast"]}
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  type={width > 720 ? "l2Regular" : "l3Regular"}
                >
                  exp.
                </Label>
              </Div>
              {isAdmin && !item.is_group_owner && (
                <Touchable onPress={handleToggleActions}>
                  <Icon name="more_vert" size={20} classNames={["colorNeutralDarkerDark"]} />
                </Touchable>
              )}
            </Div>
          </Div>
        </Div>
      </Touchable>

      {/* Action buttons shown below the item when revealed */}
      {showActions && isAdmin && (
        <div style={{ display: 'flex', flexDirection: 'row', padding: '8px', gap: '8px', backgroundColor: '#082331' }}>
          <Touchable
            classNames={[
              "flex1",
              "p12",
              "alignItemsCenter",
              "justifyContentCenter",
              "rounded",
              "bgDangerMain",
            ]}
            onPress={handleRemove}
          >
            <Label type="l3Bold" classNames={["colorWhite"]}>
              Remove
            </Label>
          </Touchable>
          <Touchable
            classNames={[
              "flex1",
              "p12",
              "alignItemsCenter",
              "justifyContentCenter",
              "rounded",
              "bgPrimaryMain",
            ]}
            onPress={handleMakeAdmin}
          >
            <Label type="l3Bold" classNames={["colorWhite"]}>
              Make Admin
            </Label>
          </Touchable>
        </div>
      )}
    </Div>
  );
}
